export const environment = {
  production: true,
  apiUrl: "https://api.ghanalibrary.org",
  opdsUrl: "https://opds.ghanalibrary.org"
};